import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f262e41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root flex-between hide-pc" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "マップ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "データ", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "帳票", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "注意報警報", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "天気予報", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "カメラ", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "メニュー", -1))
const _hoisted_15 = [
  _hoisted_14
]

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGlobalStore, TOP_VIEW_TYPES } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { useNewsHistoryStore } from '@/stores/newsStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const route = useRoute()
const router = useRouter()
const initDataStore = useInitDataStore()
const newsStore = useNewsHistoryStore()

const menuIconList = computed(() => {
  return initDataStore.headerMenus.map(m => m.icon)
})

const cautionActive = computed(() => {
  return newsStore.has10DaysNews()
})

const linkClass = (name: string) => {
  if (name === 'top') {
    return route.params.viewType === 'graphical' ? 'active' : ''
  }

  if (name === 'data') {
    return route.params.viewType === 'summary' ? 'active' : ''
  }

  return route.path.includes(name) ? 'active' : ''
}
const handleClickHome = () => {
  if (route.params.viewType === 'graphical') {
    globalStore.showLeftMenu = !globalStore.showLeftMenu
  } else {
    globalStore.showLeftMenu = false
    router.push(`/top/${TOP_VIEW_TYPES.GRAPHICAL}`)
  }
}
const handleClickData = () => {
  if (route.params.viewType === 'summary') {
    globalStore.showLeftMenu = !globalStore.showLeftMenu
  } else {
    globalStore.showLeftMenu = false
    router.push(`/top/${TOP_VIEW_TYPES.SUMMARY}`)
  }
}
const handleClickLink = (link: string) => {
  router.push(link)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      onClick: handleClickHome,
      class: _normalizeClass([linkClass('top'), "link-item home"])
    }, _hoisted_3, 2),
    _createElementVNode("li", {
      onClick: handleClickData,
      class: _normalizeClass([linkClass('data'), "link-item top"])
    }, _hoisted_5, 2),
    (_unref(menuIconList).includes('menu_list'))
      ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickLink('/reports'))),
          class: _normalizeClass([linkClass('reports'), "link-item reports"])
        }, _hoisted_7, 2))
      : _createCommentVNode("", true),
    (_unref(menuIconList).includes('menu_caution'))
      ? (_openBlock(), _createElementBlock("li", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickLink('/alerts'))),
          class: _normalizeClass([linkClass('alerts'), "link-item alerts"])
        }, _hoisted_9, 2))
      : _createCommentVNode("", true),
    (_unref(menuIconList).includes('menu_weather'))
      ? (_openBlock(), _createElementBlock("li", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClickLink('/weather'))),
          class: _normalizeClass([linkClass('weather'), "link-item weather"])
        }, _hoisted_11, 2))
      : _createCommentVNode("", true),
    (_unref(menuIconList).includes('menu_camera'))
      ? (_openBlock(), _createElementBlock("li", {
          key: 3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleClickLink('/camera'))),
          class: _normalizeClass([linkClass('camera'), "link-item camera"])
        }, _hoisted_13, 2))
      : _createCommentVNode("", true),
    _createElementVNode("li", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (handleClickLink('/menu'))),
      class: _normalizeClass([[linkClass('menu'), _unref(cautionActive) && 'has-alert'], "link-item menu"])
    }, _hoisted_15, 2)
  ]))
}
}

})